
import ChartBase from '../../chart/chart-base';

const SERIES_ID = 'ReferencePrice';
const SERIES_CLASS_NAME = 'series-color-positive';

class ChartUnderlyingMini extends ChartBase {
	start() {
		const chartConfig = {
			xAxis: {
				visible: false,
			},
			yAxis: [
				{
					visible: false,
				},
			],
		};

		// Extend chart config for this specific chart
		this.extendConfig(chartConfig);

		super.start();
	}

	// Override
	afterRenderChart() {
		this.getChartData(this.endpoint);
	}

	// Override
	onGetChartDataSuccess(data) {
		this.addDataToChart(data);
	}

	// Override
	hasQuotes(apiResponse = []) { // eslint-disable-line
		return apiResponse.length;
	}

	addDataToChart(data) {
		const seriesConfig = {
			data,
			className: SERIES_CLASS_NAME,
			id: SERIES_ID,
			name: this.options.underlyingName,
			type: 'area',
			threshold: this.threshold,
			negativeColor: true,
		};

		this.chart.addSeries(seriesConfig, true);
	}

	get endpoint() {
		const { feedUrl, apiVersion, chartName, isin } = this.options;

		return `${feedUrl}/${apiVersion}/${chartName}/default/${isin}/consolidatedperminute/intraday`;
	}

	get threshold() {
		return isNaN(parseFloat(this.options.threshold)) || isNaN(this.options.threshold)
			? 0
			: this.options.threshold;
	}
}

export default ChartUnderlyingMini;
